import React from 'react';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Badge from 'react-bootstrap/Badge';

const MoonpayButton = () => {
  const popover = (
    <Popover id="popover-sponsor">
      <Popover.Title>
        MoonPay: 50% off MoonPay fees with a credit card, debit card or bank transfer.&nbsp;
        <span className="small"><Badge variant="secondary">SPONSORED</Badge></span>
      </Popover.Title>
      <Popover.Content>
        Buy XRP with 50% off MoonPay fees, if you're a new user and you use a
        debit or credit card or a bank transfer. In partnership with Ripple.
        Your one-stop shop for the XRP ecosystem.
      </Popover.Content>
    </Popover>
  );

  return (
    <span>
        <OverlayTrigger
          key={'bottom'}
          placement={'bottom'}
          overlay={popover}
        >
          <Button
            variant="info"
            size="sm"
            href="https://api.xrpscan.com/api/v1/campaign/moonpaybutton"
            target="_blank"
            rel="noopener nofollow"
            className="dropdown-toggle"
          >50% off MoonPay fees for XRP</Button>
        </OverlayTrigger>
    </span>
  )
}

export default MoonpayButton;